var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "质检机构双随机任务",
        okText: "确认",
        cancelText: "取消",
        width: "800px",
        visible: _vm.visible,
        "confirm-loading": _vm.confirmLoading,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.formState,
            rules: _vm.rules,
            "label-col": { span: 8 },
            "wrapper-col": { span: 16 },
          },
        },
        [
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "请选择执行日期",
                        prop: "checkDate",
                      },
                    },
                    [
                      _c("a-ext-data-picker", {
                        model: {
                          value: _vm.formState.checkDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "checkDate", $$v)
                          },
                          expression: "formState.checkDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "请选择机构名称",
                        prop: "orgId",
                      },
                    },
                    [
                      _c("a-ext-gov-select", {
                        model: {
                          value: _vm.formState.orgId,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "orgId", $$v)
                          },
                          expression: "formState.orgId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "请选择小组长",
                        prop: "leader",
                      },
                    },
                    [
                      _c("a-ext-zhuan-jia-select", {
                        model: {
                          value: _vm.formState.leader,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "leader", $$v)
                          },
                          expression: "formState.leader",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "请选择小组组员",
                        prop: "member",
                      },
                    },
                    [
                      _c("a-ext-v-for-select-member", {
                        model: {
                          value: _vm.formState.member,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "member", $$v)
                          },
                          expression: "formState.member",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "请选择小组组员",
                        prop: "otherMember",
                      },
                    },
                    [
                      _c("a-ext-v-for-input-member", {
                        model: {
                          value: _vm.formState.otherMember,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "otherMember", $$v)
                          },
                          expression: "formState.otherMember",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }